function LeftSidebar({ summary, activeStatus, setActiveStatus }) {
  return (
    <div className="left-panel">
      <h3>Job Status</h3>

      <ul>
        <li className={activeStatus==="HOME" ? "active" : ""} onClick={() => setActiveStatus("HOME")}>Home</li>

        <li onClick={() => setActiveStatus("APPLIED")}>
          Applied ({summary?.applied ?? "--"})
        </li>
        <li onClick={() => setActiveStatus("NOT_APPLIED")}>
          Not Applied ({summary?.notApplied ?? "--"})
        </li>
        <li onClick={() => setActiveStatus("NOT_FIT")}>
          Not Fit ({summary?.notFit ?? "--"})
        </li>
        <li onClick={() => setActiveStatus("UNABLE_TO_APPLY")}>
          Unable To Apply ({summary?.unableToApply ?? "--"})
        </li>
      </ul>

        {/* SECTION 2: REPORTS */}
      <h3 style={{ marginTop: "20px" }}>Reports</h3>
      <ul>
        <li className={activeStatus==="REPORTS" ? "active" : ""} 
            onClick={() => setActiveStatus("REPORTS")}>
          Daily Report
        </li>
      </ul>
    </div>
  );
}

export default LeftSidebar;
